import { Pipe, PipeTransform } from '@angular/core';
import { get, orderBy } from 'lodash';

import { SortOrder } from '../grid/types/sorting.types';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  transform<T>(
    values: T[],
    path: string = null,
    order: SortOrder = SortOrder.Asc
  ): T[] {
    if (!values || !order) return values;
    if (!path) {
      if (order === 'asc') {
        return [...values].sort();
      } else {
        return [...values].sort().reverse();
      }
    }
    return orderBy<T>(values, [v => get(v, path).toLowerCase()], [order]);
  }
}
